import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MgService } from 'src/app/services/mg.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-open-call-dialog',
  templateUrl: './open-call-dialog.component.html',
  styleUrls: ['./open-call-dialog.component.scss']
})
export class OpenCallDialogComponent implements OnInit {
  public callForm: UntypedFormGroup;
  public entryEditor = ClassicEditor;
  public type: string = "I";
  public description: string = "";
  public saving: boolean = false;

  private files: FileList;

  constructor(
    private fb: UntypedFormBuilder,
    private api: MgService,
    private auth: AuthService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<OpenCallDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.callForm = this.fb.group({
      email: [undefined, [Validators.required, Validators.email]],
      name: [undefined, [Validators.required]],
      description: [undefined, [Validators.required]],
      type: ['I']
    });
  }

  public createCall() {
    this.saving = true

    this.api.postCall({
      business_user: this.auth.user.id,
      business: this.auth.user.business_id,
      description: this.description,
      type: this.type,
      priority: 'B',
    }, 'C')
      .subscribe(
        res => {
          if(this.files && this.files.length > 0) {
            this.sendCallFiles(res.data.id);
          }
          this.saving = false
          this.dialogRef.close();
          this.snackBar.open(
            `Chamado aberto: #${ res.data.number }`,
            'OK',
            {
              duration: 3500,
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
              // panelClass: ['green-snackbar']
            }
          );
        },
        err => {
          this.saving = false
          console.error(err)
        }
      )
  }

  private sendCallFiles(call_id: number) {
    let form = new FormData();

    form.append('call_id', call_id.toString());
    form.append('path', 'public/mhelp');
    for (let index = 0; index < this.files.length; index++) {
      form.append(`files[${index}]`, this.files[index]);
    }

    this.api.postCallFiles(form, false)
      .toPromise()
      .catch(err => {
        console.error(err)
      });
  }

  public filesIncuded(files: FileList) {
    this.files = files;
  }
}
